import { useLocation, useNavigate } from 'react-router';
import { Segmented } from '@/components/ui';

/* The Prayer tab holds both ṣalāh and ṣawm (fasting) — the tab bar has room
   for five, and fasting lives naturally beside the prayer log. */
export function WorshipSwitch() {
  const loc = useLocation();
  const nav = useNavigate();
  const value = loc.pathname.startsWith('/fasting') ? 'fasting' : 'prayer';
  return (
    <div className="px-4 pb-4">
      <Segmented label="Prayer or fasting" value={value} onChange={(v) => nav(v === 'fasting' ? '/fasting' : '/prayer')}
        options={[{ value: 'prayer', label: 'Ṣalāh · Prayer' }, { value: 'fasting', label: 'Ṣawm · Fasting' }]} />
    </div>
  );
}
